import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const Redo = ({
  height = 24,
  width = 24,
  color = colors.textPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      d="M18 6V10.1018H14.0177"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 18.3053C8.70794 18.3053 5.99997 15.5708 5.99997 12.18C5.99997 8.7892 8.65484 6 11.9469 6C14.4955 6 16.7256 7.64071 17.5752 10.1018"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
